import { render, staticRenderFns } from "./instruction-view.vue?vue&type=template&id=71e3d4a4&scoped=true&"
import script from "./instruction-view.vue?vue&type=script&lang=ts&"
export * from "./instruction-view.vue?vue&type=script&lang=ts&"
import style0 from "./instruction-view.vue?vue&type=style&index=0&id=71e3d4a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e3d4a4",
  null
  
)

export default component.exports